import React from 'react';
import styles from './styles.scss';
import { Col, Row } from '../../components/Grid';

const FormErrorMessage = ({ errors }) => {
  if (!Object.keys(errors).length) return null;

  return (
    <Row>
      <Col>
        <p className={styles.formError}>
          <br />
          <br />
          Bitte prüfen Sie Ihre Formulareingaben
        </p>
      </Col>
    </Row>
  );
};

export default FormErrorMessage;
